import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ParagraphEditor } from "./Editor";
import { defaultData } from "./P1BlockDefaultData";
import { P } from "./PBlock";
import { meta } from "./PBlockMetaData";

export const PBlock: BlockExport = {
  type: "component",
  Block: P,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-paragraph",
    size: 24,
  },
  defaultData,
  Editor: ParagraphEditor,
  meta,
};
